'use client';

import { NavLink } from './NavLink';
import { getAnchorIds, isNavItemActive } from './navigation.utils';
import { useScrollSpy } from '@/hooks';
import { usePathname } from 'next/navigation';
import { useSiteSettings } from '@/components/providers';

type RestProps = {
    className?: string;
};

export function NavigationMeta({ className }: RestProps) {
    const settings = useSiteSettings();
    const items = settings.navigation?.meta ?? [];
    const pathname = usePathname();
    const anchorIds = getAnchorIds(items);
    const activeAnchorId = useScrollSpy({ ids: anchorIds });

    return (
        <nav className={className} aria-label="Main navigation">
            <ul className="flex gap-4 justify-end md:gap-6">
                {items.map((item) => {
                    const isActive = isNavItemActive(item, pathname, activeAnchorId);

                    return (
                        <li key={item._key}>
                            <NavLink item={item} isActive={isActive} className="btn btn-link-white" />
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
